import React, { FC } from "react"
import loadable, { LoadableComponent } from "@loadable/component"

export type flagIconType =
  | "flag-en"
  | "flag-fi"
  | "flag-de"
  | "flag-fr"
  | "flag-es"
  | "flag-id"
  | "flag-pt"
  | "flag-nl"

type IconType =
  | "app-coverage"
  | "app-data"
  | "app-other"
  | "app-percentage-circle"
  | "app-receipt"
  | "app-sim-card"
  | "app-user"
  | "app-store"
  | "app-service-features"
  | "app-pricing"
  | "app-set-up-support"
  | "app-devices"
  | "app-user-console"
  | "app-pro-coverage"
  | "google-play"
  | "web-app"
  | "hmd-global"
  | "hmd-connect"
  | "hmd-connect-pro"
  | "dhl"
  | "arrow-down"
  | "arrow-left"
  | "arrow-right"
  | "bullet-points"
  | "check"
  | "success"
  | "close"
  | "done"
  | "download"
  | "error"
  | "hamburger-menu"
  | "external-link"
  | "mail"
  | "minus"
  | "plus"
  | "price-tag"
  | "search"
  | "sign-in"
  | "manage"
  | "secure"
  | "roaming"
  | "people"
  | "5g"
  | "cost-efficient"
  | "world"
  | flagIconType
  | undefined

export interface IconProps extends React.SVGAttributes<SVGElement> {
  icon: IconType
}

const Icon: FC<IconProps> = ({ icon, ...props }) => {
  if (!icon) return null
  let IconElement: LoadableComponent<React.SVGAttributes<SVGElement>>

  switch (icon) {
    case "app-coverage":
      IconElement = loadable(() => import("../icons/AppCoverage"))
      break
    case "app-data":
      IconElement = loadable(() => import("../icons/AppData"))
      break
    case "app-other":
      IconElement = loadable(() => import("../icons/AppOther"))
      break
    case "app-percentage-circle":
      IconElement = loadable(() => import("../icons/AppPercentageCircle"))
      break
    case "app-receipt":
      IconElement = loadable(() => import("../icons/AppReceipt"))
      break
    case "app-sim-card":
      IconElement = loadable(() => import("../icons/AppSimCard"))
      break
    case "app-user":
      IconElement = loadable(() => import("../icons/AppUser"))
      break
    case "app-store":
      IconElement = loadable(() => import("../icons/AppStore"))
      break
    case "app-service-features":
      IconElement = loadable(() => import("../icons/ServiceFeatures"))
      break
    case "app-pricing":
      IconElement = loadable(() => import("../icons/Pricing"))
      break
    case "app-set-up-support":
      IconElement = loadable(() => import("../icons/SetUpSupport"))
      break
    case "app-devices":
      IconElement = loadable(() => import("../icons/Devices"))
      break
    case "app-user-console":
      IconElement = loadable(() => import("../icons/UserConsole"))
      break
    case "app-pro-coverage":
      IconElement = loadable(() => import("../icons/ProCoverage"))
      break
    case "google-play":
      IconElement = loadable(() => import("../icons/GooglePlay"))
      break
    case "web-app":
      IconElement = loadable(() => import("../icons/WebApp"))
      break
    case "hmd-global":
      IconElement = loadable(() => import("../icons/HmdGlobal"))
      break
    case "hmd-connect":
      IconElement = loadable(() => import("../icons/HmdConnect"))
      break
    case "hmd-connect-pro":
      IconElement = loadable(() => import("../icons/HmdConnectPro"))
      break
    case "dhl":
      IconElement = loadable(() => import("../icons/DhlLogo"))
      break
    case "arrow-down":
      IconElement = loadable(() => import("../icons/ArrowDown"))
      break
    case "arrow-left":
      IconElement = loadable(() => import("../icons/ArrowLeft"))
      break
    case "arrow-right":
      IconElement = loadable(() => import("../icons/ArrowRight"))
      break
    case "bullet-points":
      IconElement = loadable(() => import("../icons/BulletPoints"))
      break
    case "check":
      IconElement = loadable(() => import("../icons/Check"))
      break
    case "success":
      IconElement = loadable(() => import("../icons/Success"))
      break
    case "close":
      IconElement = loadable(() => import("../icons/Close"))
      break
    case "done":
      IconElement = loadable(() => import("../icons/Done"))
      break
    case "download":
      IconElement = loadable(() => import("../icons/Download"))
      break
    case "error":
      IconElement = loadable(() => import("../icons/Error"))
      break
    case "hamburger-menu":
      IconElement = loadable(() => import("../icons/HamburgerMenu"))
      break
    case "external-link":
      IconElement = loadable(() => import("../icons/External"))
      break
    case "mail":
      IconElement = loadable(() => import("../icons/Mail"))
      break
    case "minus":
      IconElement = loadable(() => import("../icons/Minus"))
      break
    case "plus":
      IconElement = loadable(() => import("../icons/Plus"))
      break
    case "price-tag":
      IconElement = loadable(() => import("../icons/PriceTag"))
      break
    case "search":
      IconElement = loadable(() => import("../icons/Search"))
      break
    case "sign-in":
      IconElement = loadable(() => import("../icons/SignIn"))
      break
    case "flag-en":
      IconElement = loadable(() => import("../icons/Flag-en"))
      break
    case "flag-de":
      IconElement = loadable(() => import("../icons/Flag-de"))
      break
    case "flag-es":
      IconElement = loadable(() => import("../icons/Flag-es"))
      break
    case "flag-fr":
      IconElement = loadable(() => import("../icons/Flag-fr"))
      break
    case "flag-id":
      IconElement = loadable(() => import("../icons/Flag-id"))
      break
    case "flag-nl":
      IconElement = loadable(() => import("../icons/Flag-nl"))
      break
    case "flag-pt":
      IconElement = loadable(() => import("../icons/Flag-pt"))
      break
    case "manage":
      IconElement = loadable(() => import("../icons/Manage"))
      break
    case "secure":
      IconElement = loadable(() => import("../icons/Secure"))
      break
    case "roaming":
      IconElement = loadable(() => import("../icons/Roaming"))
      break
    case "people":
      IconElement = loadable(() => import("../icons/People"))
      break
    case "5g":
      IconElement = loadable(() => import("../icons/5G"))
      break
    case "cost-efficient":
      IconElement = loadable(() => import("../icons/CostEfficient"))
      break
    case "world":
      IconElement = loadable(() => import("../icons/World"))
      break
    default:
      return null
  }

  if (IconElement) {
    return <IconElement {...props} />
  } else {
    console.warn(`${icon} dose not exist`)
    return null
  }
}

export default Icon
